export default __webpack_public_path__ + "static/364086_1_0-da5146bf5703c5c455ea90a2c3e92950.woff2";